import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { EjercicioProvider } from "@/context/EjercicioContext";
import Home from "@/pages/Home";
import Claridad from "@/pages/Claridad";
import TuPaso from "@/pages/TuPaso";
import Sesion from "@/pages/Sesion";
import Area from "@/pages/Area";
import Academia from "@/pages/Academia";
import Medita from "@/pages/Medita";
import Comunidad from "@/pages/Comunidad";
import Seguimiento from "@/pages/Seguimiento";
import Admin from "@/pages/Admin";
import Privacidad from "@/pages/Privacidad";

function App() {
  return (
    <div className="App">
      <EjercicioProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/claridad" element={<Claridad />} />
            <Route path="/tu-paso" element={<TuPaso />} />
            <Route path="/sesion" element={<Sesion />} />
            <Route path="/area" element={<Area />} />
            <Route path="/academia" element={<Academia />} />
            <Route path="/medita" element={<Medita />} />
            <Route path="/comunidad" element={<Comunidad />} />
            <Route path="/seguimiento" element={<Seguimiento />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacidad" element={<Privacidad />} />
          </Routes>
        </BrowserRouter>
      </EjercicioProvider>
    </div>
  );
}

export default App;
